import { render, staticRenderFns } from "./CustomerSubscription.vue?vue&type=template&id=72dcf7e8"
import script from "./CustomerSubscription.vue?vue&type=script&lang=js"
export * from "./CustomerSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports